// Code generated by @ads-platform/rtkq-codegen v1.1.0. EDIT ONLY TYPES IMPORT PATH IF NECESSARY.

import { separateApiCampaigns as api } from '#adapter/api/campaigns/separate-api-campaign';

import * as Types from './types';

const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getApiV5Configvalues: build.query<
        Types.IGetApiV5ConfigvaluesApiResponse,
        Types.IGetApiV5ConfigvaluesApiArg
        >({
            query: () => ({
                url: '/api/v5/configvalues'
            })
        })
    }),
    overrideExisting: false
});

export { injectedRtkApi as rtkApi };
export const { useGetApiV5ConfigvaluesQuery } = injectedRtkApi;
